<template>
  <div class="border border-gray-200 sm:rounded-lg text-gray-700 font-normal text-sm" :class="overflowClass">
    <table class="min-w-full divide-y divide-gray-200">
      <thead>
        <tr class="border-b border-gray-200">
          <th
            v-for="field in fields"
            :key="field.key"
            :class="['font-medium uppercase text-gray-600 text-xs tracking-wide text-left py-2 bg-gray-100 px-4 whitespace-no-wrap', field.thClass]"
            @click="(field.isSortable && handleHeaderClick(field)) || (field.onClick && field.onClick())"
          >
            <div v-if="field.hasOwnProperty('isCheckbox')">
              <base-checkbox :value="field.key" v-model="headerCheckValue" @update:model-value="emitChecked" />
            </div>
            <div v-else :class="['inline-flex items-center', { 'underline cursor-pointer': field.isSortable }]">
              {{ field.title }}
              <div
                ref="button-tooltip-group"
                class="group relative px-1 py-2 cursor-pointer"
                @mouseover="showTooltip(field.key)"
                @mouseout="hideTooltip(field.key)"
                v-if="field.tooltip"
              >
                <information-icon class="flex-none w-3 h-3 my-auto text-gray-800" />
                <base-tooltip :ref="'infoTooltip-' + field.key" :textValue="field.tooltip" />
              </div>
              <component class="w-3.5 h-3.5 ml-1" v-if="sortKey === field.key" :is="sortDesc ? 'chevron-down-icon' : 'chevron-up-icon'" />
            </div>
          </th>
        </tr>
      </thead>
      <tbody v-if="loading" class="bg-white">
        <tr :class="['border-gray-200', { 'border-b': key < computedLoadingRows }]" v-for="key in computedLoadingRows" :key="`loading-row-${key}`">
          <slot name="loading-row">
            <td v-for="field in fields" :key="field.key" :class="['py-3 px-4', field.tdClass]" :align="field.align">
              <slot name="loading-cell">
                <base-skeleton-loader class="h-5 w-full" />
              </slot>
            </td>
          </slot>
        </tr>
      </tbody>
      <tbody v-else class="bg-white">
        <tr v-for="(item, index) in items" :key="index" :class="['border-gray-200', { 'border-b': index + 1 < items.length }]">
          <td
            v-for="field in fields"
            :key="`${index}-${field.key}`"
            :class="[
              'py-3 px-4',
              field.tdClass,
              { 'rounded-bl-lg': index + 1 === items.length && field.key === fields[0].key },
              { 'rounded-br-lg': index + 1 === items.length && field.key === fields[fields.length - 1].key },
            ]"
            :align="field.align"
          >
            <slot :item="item" :index="index" :name="field.key">{{ item[field.key] }}</slot>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-show="items && !items.length && !loading" class="bg-white w-full">
      <slot name="empty-state" />
    </div>
  </div>
</template>

<script>
import { ChevronDownIcon, ChevronUpIcon, InformationIcon } from "@/assets/svgs";

export default {
  emits: ["update:sortDesc", "update:sortKey", "checked"],
  components: {
    ChevronDownIcon,
    ChevronUpIcon,
    InformationIcon,
  },
  props: {
    loading: Boolean,
    fields: Array,
    items: Array,
    sortKey: String,
    sortDesc: Boolean,
    loadingRows: { type: Number, default: 3 },
    overflowVisible: { type: Boolean, default: false },
  },
  data() {
    return {
      headerCheckValue: [],
    };
  },
  computed: {
    overflowClass() {
      return this.overflowVisible ? "overflow-visible" : "overflow-auto";
    },
    computedLoadingRows() {
      if (this.items && this.items.length > 0) return this.items.length;
      else return this.loadingRows;
    },
  },
  methods: {
    handleHeaderClick(field) {
      this.$emit("update:sortDesc", this.sortKey === field.key ? !this.sortDesc : true);
      this.$emit("update:sortKey", field.key);
    },
    emitChecked() {
      this.$emit("checked", this.headerCheckValue);
    },
    clearChecked() {
      this.headerCheckValue = [];
    },
    showTooltip(key) {
      let index = "infoTooltip-" + key;
      this.$refs[index][0].show();
    },
    hideTooltip(key) {
      let index = "infoTooltip-" + key;
      this.$refs[index][0].hide();
    },
  },
};
</script>
